import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faBellSlash } from "@fortawesome/free-solid-svg-icons";

import { getLabelFQA, getTaskLink } from "../lib/constants";
import { MOMENT_LONG_DATE_FORMAT } from "shared/constants";
import { usePostHistory } from "shared/hooks/api/use-post-history";

const DateNameDisplay = ({ date, label, user, isPostDateUpdated }) => {
    if (!date) {
        return null;
    }

    return (
        <div className="data-name-display">
            <p>
                <b>
                    {!isPostDateUpdated ? <FontAwesomeIcon icon={faBellSlash} /> : ""}
                    {label}
                </b>
                <br />
                {moment.utc(date).format(MOMENT_LONG_DATE_FORMAT)} by
                <br />
                {user}
            </p>
        </div>
    );
};

const FinalQATaskDetail = ({ task, isCurrentTask }) => {
    const { data: activities } = usePostHistory(task.key);
    const taskLink = getTaskLink(task);

    return (
        <>
            <div className="task-history -scrollable">
                {!isCurrentTask && taskLink && (
                    <a href={taskLink} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </a>
                )}
                {activities &&
                    activities.map(({ postedBy, datePosted, isPostDateUpdated }, i) => (
                        <DateNameDisplay
                            key={`${postedBy}_${i}`}
                            label={getLabelFQA(activities.length, i)}
                            date={datePosted}
                            user={postedBy}
                            isPostDateUpdated={isPostDateUpdated}
                        />
                    ))}
            </div>
            <h6>
                <FontAwesomeIcon icon={faBellSlash} /> Post date was not updated
            </h6>
        </>
    );
};

export default FinalQATaskDetail;
